var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef, useEffect, useRef, useState } from 'react';
import classnames from 'classnames';
import Svg from '../Svg';
import './style/index.scss';
var COLLAPSE_HEIGHT_RATIO = 0.5;
var ProAdMsgCollapse = forwardRef(function ProAdMsgCollapse(_a, forwardedRef) {
    var enabled = _a.enabled, recomputeKey = _a.recomputeKey, measureRef = _a.measureRef, children = _a.children, className = _a.className, restProps = __rest(_a, ["enabled", "recomputeKey", "measureRef", "children", "className"]);
    var _b = useState(true), collapsed = _b[0], setCollapsed = _b[1];
    var _c = useState(false), needCollapse = _c[0], setNeedCollapse = _c[1];
    var innerWrapRef = useRef(null);
    useEffect(function () {
        if (!enabled) {
            setNeedCollapse(false);
            setCollapsed(true);
            return;
        }
        var judgeNeedCollapse = function () {
            var wrapEl = innerWrapRef.current;
            if (!wrapEl) {
                return;
            }
            var maxHeight = Math.floor(window.innerHeight * COLLAPSE_HEIGHT_RATIO);
            var contentEl = (measureRef === null || measureRef === void 0 ? void 0 : measureRef.current) || wrapEl;
            var contentHeight = contentEl.scrollHeight;
            setNeedCollapse(contentHeight > maxHeight);
        };
        var isVisible = function () {
            var wrapEl = innerWrapRef.current;
            if (!wrapEl) {
                return false;
            }
            // 被 display:none 隐藏时，offsetParent 通常为 null。
            return !!wrapEl.offsetParent;
        };
        var rafId = window.requestAnimationFrame(judgeNeedCollapse);
        var timeoutId = window.setTimeout(judgeNeedCollapse, 0);
        window.addEventListener('resize', judgeNeedCollapse);
        var mutationObserver = new MutationObserver(function () {
            if (isVisible()) {
                judgeNeedCollapse();
            }
        });
        mutationObserver.observe(document.body, {
            subtree: true,
            attributes: true,
            attributeFilter: ['class', 'style']
        });
        var imgRoot = (measureRef === null || measureRef === void 0 ? void 0 : measureRef.current) || innerWrapRef.current;
        var imgs = imgRoot ? Array.from(imgRoot.querySelectorAll('img')) : [];
        imgs.forEach(function (img) {
            img.addEventListener('load', judgeNeedCollapse);
            img.addEventListener('error', judgeNeedCollapse);
        });
        return function () {
            window.cancelAnimationFrame(rafId);
            window.clearTimeout(timeoutId);
            window.removeEventListener('resize', judgeNeedCollapse);
            mutationObserver.disconnect();
            imgs.forEach(function (img) {
                img.removeEventListener('load', judgeNeedCollapse);
                img.removeEventListener('error', judgeNeedCollapse);
            });
        };
    }, [enabled, recomputeKey, measureRef]);
    return (React.createElement("div", __assign({ ref: forwardedRef, className: classnames('pro-ad-msg-collapse', {
            'pro-ad-msg-collapse-expanded': enabled && needCollapse && !collapsed,
            'pro-ad-msg-collapse-collapsed': enabled && needCollapse && collapsed
        }, className) }, restProps),
        React.createElement("div", { ref: innerWrapRef, className: "pro-ad-msg-collapse-content" }, children),
        enabled && needCollapse && collapsed && (React.createElement(React.Fragment, null,
            collapsed && React.createElement("div", { className: "pro-ad-msg-collapse-mask" }),
            React.createElement("div", { className: "pro-ad-msg-collapse-padding-bottom" }),
            React.createElement("div", { className: "pro-ad-msg-collapse-toggle", onClick: function () { return setCollapsed(function (prev) { return !prev; }); } }, collapsed ? React.createElement(Svg.DownRectFill, null) : '收起')))));
});
export default ProAdMsgCollapse;
